/**
 * 保险产品类
 */
export default class Insurance {
  constructor(insurance = {}) {
    this.bxid = insurance.bxid // (string, optional): 保险产品id ,
    this.be = insurance.be // (number, optional): 保额 单位万元 ,
    this.besm = insurance.besm // (string, optional): 保额说明 ,
    this.bxgs = insurance.bxgs // (string, optional): 保险公司id ,
    this.compName = insurance.bxgsmc || insurance.bxcpCompName // (string, optional): 保险公司名称 ,
    this.bxmc = insurance.bxmc || insurance.bxcpmc // (string, optional): 保险名称 ,
    this.bxtk = insurance.bxtk // (string, optional): 保险条款 ,
    // this.bxtk = 'http://oss.lingduankeji.com/index1.html#/app/insurance/sysSet/list,,'
    this.bxxz = insurance.bxxz // (string, optional): 保险险种id ,
    this.bxxzmc = insurance.xzmc || insurance.bxxzmc // (string, optional): 险种名称 ,
    this.qzbd = insurance.qzbd // (string, optional): 是否强制绑定 '0'自愿购买，自行勾选 '1'是强制绑定  '2'赠送 '3'自愿购买，默认选中
    this.saleprice = insurance.saleprice || insurance.salePrice || 0 // (number, optional): 销售价 ,
    this.sxgzDesc = insurance.sxgzDesc || insurance.xsgzDesc // (string, optional): 生效规则描述 ,
    this.synl = insurance.synl // (string, optional): 适用年龄 ,
    this.xgfs = insurance.xgfs // (integer, optional): 限购份数 ,
    this.xssm = insurance.xssm // (string, optional): 销售说明
    this.hbh = insurance.hbh // (string, optional): 航班号/车次 ,
    this.showDownload = Boolean(insurance.showDownload) // (integer, optional): 是否支持在线保单下载 0否 1是 ,
    this.bbrList = insurance.bbrList ? insurance.bbrList.map(bbr => new Bbr(bbr)) : []
  }
  
  /**
   * 产品说明
   */
  get cpsm () {
    return `${this.besm}#${this.sxgzDesc}#${this.xssm || ''}`
  }
  
  /**
   * 保险名称标题
   * 取bxmc字段中 第一个全角括号前面的内容
   * '中银航综险E款（单次50元160万+延误3h300元）'
   */
  get bxmcTitle () {
    let index = this.bxmc.indexOf('（')
    return index > -1 ? this.bxmc.slice(0, index) : this.bxmc
  }

  /**
   * 保险描述
   * 取bxmc字段中 全角括号的内容，并以 '+' 号分割
   * 没有则返回空数组
   */
  get bxmcLabels () {
    let startIndex = this.bxmc.indexOf('（'),
      endIndex = this.bxmc.indexOf('）')
    
    if (startIndex > -1) {
      let labels = this.bxmc.slice(startIndex + 1, endIndex)
      return labels.split('+')
    } else {
      return []
    }
  }

  /**
   * 字段格式
   * besm: '保额说明1#保额说明1#保额说明1'
   * bxtk: '保险条款1,保险条款1,保险条款1'
   */
  get besmList () {
    return this.besm ? this.besm.split('#') : []
  }

  get bxtkList () {
    return this.bxtk ? this.bxtk.split(',') : []
  }
  
  /**
   * 只返回保险下单需要的字段
   */
  filterFields () {
    return {
      bxid: this.bxid,
      bxmc: this.bxmc,
      bxxz: this.bxxz,
      bxxzmc: this.bxxzmc,
      saleprice: this.saleprice,
      sxgz: this.sxgz,
      cpsm: this.cpsm
    }
  }
}

class Bbr {
  constructor (bbr) {
    this.bBorn = bbr.bBorn // (string, optional): 被保人生日 ,
    this.bIdNo = bbr.bIdNo // (string, optional): 被保人证件号码 ,
    this.bIdType = bbr.bIdType // (string, optional): 被保人证件类型 ,
    this.bSex = bbr.bSex // (string, optional): 被保人性别 ,
    this.bbr = bbr.bbr // (string, optional): 被保人姓名 ,
    this.bd = bbr.bd // (string, optional): 保单下载地址 ,
    this.bdh = bbr.bdh // (string, optional): 保单号 ,
    this.bdsxsj = bbr.bdsxsj // (string, optional): 保单生效时间 ,
    this.tbzt = bbr.tbzt // (string, optional): 订单状态 ,
    this.tbztDesc = bbr.tbztDesc // (string, optional): 订单状态中文描述 ,
    this.xc = bbr.xc // (string, optional): 行程
  }
}
